class Confetti {
  constructor(canvas) {
    this.canvas = canvas
    this.ctx = canvas.getContext('2d')
    this.W = window.innerWidth
    this.H = window.innerHeight
    this.mp = 150
    this.particles = []
    this.angle = 0
    this.confettiActive = true 
    this.animationComplete = false
    this.animationHandler = null
    this.colors = ['DodgerBlue', 'Gold', 'pink', 'SlateBlue', 'lightblue', 'Violet', 'PaleGreen', 'Crimson']

    this.resizeCanvas()
    window.addEventListener('resize', () => this.resizeCanvas())
  }

  random(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  getRandomColor(index) {
    return this.colors[index % this.colors.length]
  }

  createParticle(index, variant, originX, originY) {
    const r = this.random(10, 30)
    const d = Math.random() * this.mp + 10

    let x, y
    if (variant === 'burst') {
      // Start from the specified origin point
      x = originX
      y = originY
    } else {
      // Default 'full' variant - spread across top
      x = Math.random() * this.W
      y = Math.random() * this.H - this.H
    }

    return {
      x,
      y,
      r,
      d,
      color: this.getRandomColor(index),
      tilt: Math.floor(Math.random() * 10) - 10,
      tiltAngleIncremental: Math.random() * 0.07 + 0.05,
      tiltAngle: 0,
      velocityX: variant === 'burst' ? (Math.random() - 0.5) * 10 : 0,
      velocityY: variant === 'burst' ? -(Math.random() * 15 + 10) : 0,
      draw(ctx) {
        ctx.beginPath()
        ctx.lineWidth = this.r / 2
        ctx.strokeStyle = this.color
        ctx.moveTo(this.x + this.tilt + this.r / 4, this.y)
        ctx.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 4)
        ctx.stroke()
      }
    }
  }

  initParticles(variant = 'full', originX = 0, originY = 0) {
    this.variant = variant
    this.particles = []
    const particleCount = variant === 'burst' ? 50 : this.mp
    for (let i = 0; i < particleCount; i++) {
      this.particles.push(this.createParticle(i, variant, originX, originY))
    }
  }

  resizeCanvas() {
    this.canvas.width = this.W = window.innerWidth
    this.canvas.height = this.H = window.innerHeight
  }

  stepParticle(particle, index) {
    particle.tiltAngle += particle.tiltAngleIncremental
    
    if (this.variant === 'burst') {
      // Burst physics
      particle.velocityY += 0.5 // Gravity
      particle.y += particle.velocityY
      particle.x += particle.velocityX
      particle.tilt = Math.sin(particle.tiltAngle - index / 3) * 15
    } else {
      // Default full variant physics
      particle.y += (Math.cos(this.angle + particle.d) + 3 + particle.r / 2) / 2
      particle.x += Math.sin(this.angle)
      particle.tilt = Math.sin(particle.tiltAngle - index / 3) * 15
    }
  }

  draw() {
    const ctx = this.ctx
    ctx.clearRect(0, 0, this.W, this.H)
    const particleCount = this.variant === 'burst' ? 50 : this.mp
    for (let i = 0; i < particleCount; i++) {
      this.stepParticle(this.particles[i], i)
      this.particles[i].draw(ctx)
    }
    this.update()
  }

  update() {
    let remaining = 0
    this.angle += 0.01
    const particleCount = this.variant === 'burst' ? 50 : this.mp

    for (let i = 0; i < particleCount; i++) {
      const p = this.particles[i]

      if (this.animationComplete) return

      if (!this.confettiActive && p.y < -15) {
        continue
      }

      if (p.y <= this.H) {
        remaining++
      } else if (this.confettiActive && this.variant !== 'burst') {
        p.y = this.H + 100
      }
    }

    if (!this.confettiActive && remaining === 0) {
      this.stop()
    }
  }

  start() {
    this.animationComplete = false
    const loop = () => {
      if (this.animationComplete) return
      this.draw()
      // eslint-disable-next-line no-undef
      this.animationHandler = requestAnimationFrame(loop)
    }
    loop()
  }

  stopEmitting() {
    this.confettiActive = false
  }

  stop() {
    this.animationComplete = true
    this.ctx.clearRect(0, 0, this.W, this.H)
    // eslint-disable-next-line no-undef
    cancelAnimationFrame(this.animationHandler)
  }
}

export function initConfetti(duration = 3000, variant = 'full', element = null) {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (prefersReducedMotion) return

  const canvas = element ? element.querySelector('.js-confetti-canvas') : document.querySelector('.js-confetti-canvas')
  if (!canvas) return

  const confetti = new Confetti(canvas)
  
  // For burst variant, get the position of the element
  let originX = confetti.W / 2
  let originY = confetti.H / 2
  
  if (variant === 'burst' && element) {
    const rect = element.getBoundingClientRect()
    originX = rect.left + rect.width / 2
    originY = rect.top
  }
  
  confetti.initParticles(variant, originX, originY)
  confetti.start()

  setTimeout(() => {
    confetti.stopEmitting()
  }, duration)
}

export function triggerConfetti(shouldTrigger = true) {
  const el = document.querySelector('#js-c-confetti')
  if (el && shouldTrigger && el.dataset.trigger !== 'true') {
    el.dataset.trigger = 'true'
  }
}
